import { create } from 'zustand';

type TStore = {
  selectedCommentId: string | undefined;
  setSelectedCommentId: (commentId: string | undefined) => void;
};

const useCommentStore = create<TStore>((set) => ({
  selectedCommentId: undefined,
  setSelectedCommentId: (commentId) => set({ selectedCommentId: commentId }),
}));

export default useCommentStore;
